import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import { getShowBrandCompany } from '../../../services/brands';
import type { ShowBrandCompany } from '../../../types/brand';

type Props = {
  isAllStoppedRecruitments: boolean;
  brandId: number;
  instagramIcon: string;
  noimage: string;
  hoverIcon: string;
  isPc: boolean;
  dataCategory: {
    brandcontent: string;
    stopbrandcontent: string;
  };
  dataValue: any;
};

export const Component: FunctionComponent<Props> = ({
  isAllStoppedRecruitments,
  brandId,
  instagramIcon,
  noimage,
  hoverIcon,
  isPc,
  dataCategory,
  dataValue,
}) => {
  const [companyData, setCompanyData] = useState<ShowBrandCompany | null>(null);

  useEffect(() => {
    const request = async () => {
      const response = await getShowBrandCompany(brandId);
      setCompanyData(response);
    };
    request();
  }, []);

  if (!companyData || !companyData.name) {
    return null;
  }

  return (
    <Presentation
      isAllStoppedRecruitments={isAllStoppedRecruitments}
      brandId={brandId}
      instagramIcon={instagramIcon}
      noimage={noimage}
      hoverIcon={hoverIcon}
      isPc={isPc}
      companyData={companyData}
      dataCategory={dataCategory}
      dataValue={dataValue}
    />
  );
};
